<template>
  <div>
    <div class="my-4" v-if="integrationDetails">
      <validated-input label="PB Customer Number" v-model="integrationDetails.results[0].response.customerNumber" />
      <validated-input label="PB warehouse prefix" v-model="integrationDetails.results[0].reqBody.profillPrefix" />
      <validated-input label="P3 Customer Number" v-model="integrationDetails.results[1].response.customerNumber" />

      <validated-input label="P3 warehouse prefix" v-model="integrationDetails.results[1].reqBody.profillPrefix" />

      <validated-input label="P7 Customer Number" v-model="integrationDetails.results[2].response.customerNumber" />

      <validated-input label="P7 warehouse prefix" v-model="integrationDetails.results[2].reqBody.profillPrefix" />
      <!-- <validated-input :validate="{ required: true }" label="Token" v-model="integrationDetails.token" /> -->
    </div>
  </div>
</template>

<script>
export default {
  inject: ['$validator'],
  name: 'Profill',
  props: {
    integrationDetails: {
      type: Object,
      required: true
    }
  }
};
</script>
